import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { workspaceQueryOptions } from '~/modules/workspaces/query';
import { WorkspaceRoute } from '~/routes/workspaces';

export const useWorkspaceQuery = () => {
  const { idOrSlug, orgIdOrSlug } = useParams({ from: WorkspaceRoute.id });
  const queryOptions = workspaceQueryOptions(idOrSlug, orgIdOrSlug);
  const result = useSuspenseQuery(queryOptions);

  return {
    ...result.data,
    projects: result.data.projects
      .filter(({ membership }) => !membership?.archived)
      .sort((a, b) => (a.membership?.order ?? 0) - (b.membership?.order ?? 0)),
  };
};
